const setupInputs = () => {
	const inputs = document.querySelectorAll( 'input:not([type="hidden"]):not([type="checkbox"]), textarea' )
	inputs.forEach( input => {
		console.log( 'input', input )
		if ( input.value.trim() !== '' ) {
			const gFieldParent = input.closest( '.gfield' )
			const label = gFieldParent.querySelector( 'label' )
			label.style.display = 'none';
		}
		input.addEventListener( 'focus', () => {
			console.log( 'focus', input )
			const gFieldParent = input.closest( '.gfield' )
			const label = gFieldParent.querySelector( 'label' )
			label.style.display = 'none';
		} )
		input.addEventListener( 'blur', () => {
			const gFieldParent = input.closest( '.gfield' )
			const label = gFieldParent.querySelector( 'label' )
			label.style.display = 'block';
			if ( input.value.trim() !== '' ) {
				// const gFieldParent = input.closest( '.gfield' )
				// const label = gFieldParent.querySelector( 'label' )
				label.style.display = 'none';
			}
		} )
	} )
}

document.addEventListener( 'DOMContentLoaded', () => {
	const connectWithUsFormExists = document.querySelector( '.connect-with-us-form' );
	if ( connectWithUsFormExists ) {
		setupInputs()
		jQuery( document ).on( 'gform_post_render', () => setupInputs() );
	}
} )
